import { render, staticRenderFns } from "./LinkedIn.vue?vue&type=template&id=4be55288&scoped=true&"
import script from "./LinkedIn.vue?vue&type=script&lang=js&"
export * from "./LinkedIn.vue?vue&type=script&lang=js&"
import style0 from "./LinkedIn.vue?vue&type=style&index=0&id=4be55288&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be55288",
  null
  
)

export default component.exports